import { useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const MetaDescription = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', `${t('home.title')} - ${t('home.subtitle')}`);
    }
  }, [t]);

  return null;
};

export default MetaDescription;
